import { useMutation, useQueryClient } from '@tanstack/react-query';

import { uploadSupplierGroupLogo } from '../../../../common/api/clients/supplierGroups.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useSupplierGroupLogoUpload = (groupId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (file: File) => uploadSupplierGroupLogo(groupId, file),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.supplierGroups.detail(groupId).queryKey });
        },
    });
};
